import React, { useContext } from "react";
import "../style/ProjectPresention.css";
import gameImg from "../img/game.jpg";
import AOS from "aos";

AOS.init();
const ProjectPresention = ({
  img,
  gameTitle,
  gameDescription,
  genre,
  engine,
  platfrom,
  link
}) => {
  return (
    <div data-aos="fade-right" className="project_div">
      <div className="project_img">
        <img src={img} alt="Project Image" />
      </div>
      <div className="porjectInfo_div">
        <h1>{gameTitle}</h1>
        <p className="description_span">{gameDescription}</p>
        <div className="projectDetails">
          <p>Genre: {genre}</p>
          <p>Engine: {engine} </p>
          <p>Platform: {platfrom}</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectPresention;
